export const aggregationOptions = {
    group : [
        {value: 'daily', name: 'Daily'},
        {value: 'weekly', name: 'Weekly'},
        {value: 'monthly', name: 'Monthly'},
        {value: 'quarterly', name:'Quarterly'},
        {value: 'yearly', name: 'Annually'},
    ],
    agg: [
        {value: 'mean', name: 'Average'},
        {value: 'sum', name:'Sum'},
        {value: 'max', name: 'Max'},
        {value: 'min', name: 'Min'},
        {value: 'last_value', name: 'Last Value'},
        {value: 'first_value', name: 'First Value'}
    ]
}

export function getDisableGroupByOptions(datasetFrequency, options = aggregationOptions.group){
    const frequencyIndex = options.findIndex(option => option.value === datasetFrequency)
    return options.map((option, i) =>{
        return {
            ...option,
            disable : i < frequencyIndex
        }
    })
}

export function getDatasetFrequency(datasets, datasetValue) {
    return datasetValue && datasets?.find(data => data.value === datasetValue)?.frequency
}

export const disableAggOptions = (group, agg, originalFrequency) => {
    if(group === originalFrequency){
        return ''
    }
    return agg === '' ? 'mean' : agg
}
